import { compose, setDisplayName, withProps } from 'recompose';
import { __, defaultTo, prop } from 'ramda';

import { Corporate } from './Corporate';
import { Minimal } from './Minimal';
import { Product } from './Product';

const footers = {
  corporate: Corporate,
  minimal: Minimal,
  product: Product,
};

const componentMap = compose(defaultTo(Minimal), prop(__, footers));

export const enhance = compose(
  setDisplayName('FooterEnhanced'),
  withProps(({ templateStyle }) => ({
    FooterComponent: componentMap(templateStyle),
  }))
);
